import { Key, Lock, Settings, Shield, User } from "lucide-react";

const tabs = [
  { id: "account", label: "Account", short: "Identity, Telegram and access", icon: User, requiresLicense: false },
  { id: "general", label: "General", short: "Destinations and visitor pages", icon: Settings, requiresLicense: true },
  { id: "security", label: "Security & Evasion", short: "Filters, delays and rotation", icon: Key, requiresLicense: true },
  { id: "advanced", label: "Advanced Security", short: "Signals and agent defenses", icon: Shield, requiresLicense: true },
];

export const SettingsNavigation = ({ activeTab, isLicensed, onChange }) => (
  <nav className="settings-subnav" data-testid="settings-subnav-sidebar" aria-label="Settings areas">
    <div className="hidden border-b border-slate-800 px-3 pb-4 lg:block">
      <p className="text-xs font-semibold uppercase text-slate-500">Configuration</p>
      <p className="mt-1 text-xs leading-5 text-slate-600">Choose an area to manage.</p>
    </div>
    <div className="flex min-w-max gap-2 p-2 lg:min-w-0 lg:flex-col lg:gap-1.5 lg:p-3">
      {tabs.map((tab) => {
        const locked = tab.requiresLicense && !isLicensed;
        const active = activeTab === tab.id;
        const Icon = locked ? Lock : tab.icon;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => !locked && onChange(tab.id)}
            disabled={locked}
            className={`settings-nav-item ${active ? "settings-nav-item-active" : ""} ${locked ? "settings-nav-item-locked" : ""}`}
            data-testid={`tab-${tab.id}`}
            aria-current={active ? "page" : undefined}
            title={locked ? "An active license is required" : tab.label}
          >
            <span className="settings-nav-icon"><Icon className="h-4 w-4" /></span>
            <span className="min-w-0 text-left">
              <span className="block whitespace-nowrap text-sm font-semibold">{tab.label}</span>
              <span className="hidden truncate text-xs text-slate-500 lg:block">{locked ? "License required" : tab.short}</span>
            </span>
          </button>
        );
      })}
    </div>
  </nav>
);

export const SettingsContextHeader = ({ activeTab, isLicensed }) => {
  const tab = tabs.find((item) => item.id === activeTab) || tabs[0];
  const Icon = tab.icon;
  return (
    <div className="settings-context-header" data-testid="settings-context-header">
      <div className="flex min-w-0 items-center gap-3">
        <span className="settings-context-icon"><Icon className="h-5 w-5" /></span>
        <div className="min-w-0">
          <h2 className="truncate text-lg font-semibold text-white" data-testid="settings-context-title">{tab.label}</h2>
          <p className="truncate text-sm text-slate-500">{tab.short}</p>
        </div>
      </div>
      <span className={`settings-access-badge ${isLicensed ? "settings-access-active" : "settings-access-pending"}`} data-testid="settings-access-status">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {isLicensed ? "Licensed workspace" : "Account access"}
      </span>
    </div>
  );
};